import { useContext } from "react";
import M16Icon from "../../../assets/M16Icon.png";
import { ControllerContext } from "../../../contexts/controller";

import MultipleUpload from "../../../pages/MultipleUpload";

import {
  SectionOneContent,
  SectionOneHeader,
  SectionOneHeaderTitle,
  SectionOneHeaderTitleImgDiv,
  SectionOneHeaderTitleImg,
  SectionOneHeaderTitleName,
  SectionOneHeaderDescription,
  SectionOneHeaderDescriptionDiv,
  SectionOneHeaderDescriptionP,
  SectionOneHeaderDescriptionButton,
  SectionOneSection,
  SectionOneContentContent,
  HomeUIDDiv,
  SystemAcessDiv,
  MonitoringAcessDiv,
  HomeUIDTitle,
  HomeUIDContent,
  HomeUIDContentDescription,
  HomeUIDContentButton,
  SystemAcessTitle,
  SystemAcessContent,
  SystemAcessContentDescription,
  MonitoringAcessTitle,
  MonitoringAcessContent,
  MonitoringAcessDescription,
  OverallSystemStatusDiv,
  OverallSystemStatusContent,
  OverallSystemStatusTitle,
  OverallSystemStatusDescription,
  ChecksDiv,
  ChecksContent,
  ChecksIconDiv,
  ChecksDescription,
  DashboardDiv,
  DashboardContent,
  DashboardTitle,
  DashboardValue,
  DashboardValueSpan,
  DashboardIconDiv,
  DashboardIconDivContent,
  DashboardIcon,
} from "./styles";

const HomeOnlineSVG = () => {
  return (
    <svg viewBox="0 0 24 24" style={{width: "1.125rem", height: "1.125rem", marginRight:"20px"}}>
      <path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z" 
        fill="rgb(35, 197, 20)"
      ></path>
    </svg>
  )
}

const HomeOfflineSVG = () => {
  return (
    <svg viewBox="0 0 24 24" style={{width: "1.125rem", height: "1.125rem", marginRight:"20px"}}>
      <path d="M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22C17.53,22 22,17.53 22,12C22,6.47 17.53,2 12,2M14.59,8L12,10.59L9.41,8L8,9.41L10.59,12L8,14.59L9.41,16L12,13.41L14.59,16L16,14.59L13.41,12L16,9.41L14.59,8Z" 
        fill="rgb(197, 41, 42)"
      ></path>
    </svg>
  )
}

const ThreeDotsSVG = () => {
  return (
    <svg viewBox="0 0 24 24" style={{width: "1.5rem", height: "1.5rem", marginRight:"20px"}}>
      <path d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" 
        fill="#A89968">
      </path>
    </svg>
  )
}

const UDIButtonSVG = () => {
  return (
    <svg viewBox="0 0 24 24" style={{width: "1.5rem", height: "1.5rem", marginRight:"20px"}}>
      <path d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z" 
        fill="#A89968">
      </path>
    </svg>
  )
}

const SystemAcessCheckSVG = () => {
  return (
    <svg viewBox="0 0 24 24" style={{width: "1.125rem", height: "1.125rem", marginRight:"12px"}}>
      <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" 
        fill="rgb(35, 197, 20)">
      </path>
    </svg>
  )
}

const MonitoringAcessSVG = () => {
  return (
    <svg viewBox="0 0 24 24" style={{width: "1.12rem", height: "1.12rem", marginRight:"12px"}}>
      <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" 
        fill="rgb(35, 197, 20)">
      </path>
    </svg>
  )
}

const ChecksOKSVG = () => {
  return (
    <svg viewBox="0 0 24 24" style={{width: "1.125rem", height: "1.125rem", marginRight:"12px"}}>
      <path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z" 
        fill="rgb(35, 197, 20)">
      </path>
    </svg>
  )
}

const CircularProgressBarSVG = () => {
  return (
    <svg viewBox="0 0 100 100">
      <path
        d="M 50,50 m 0,-39 a 39,39 0 1 1 0,78 a 39,39 0 1 1 0,-78"
        strokeWidth="22"
        fillOpacity="0"
        stroke="rgb(237, 234, 229)"
        strokeLinecap="butt"
        strokeDasharray="245.044px, 245.044px"
        strokeDashoffset="0px"
        ></path>
      <path
        d="M 50,50 m 0,-39 a 39,39 0 1 1 0,78 a 39,39 0 1 1 0,-78"
        strokeWidth="22"
        fillOpacity="0"
        stroke="rgb(255, 95, 0)"
        strokeLinecap="butt"
        // transitionDuration="0.5s"
        strokeDasharray="245.044px, 245.044px"
        strokeDashoffset="213.85px"
        ></path>
    </svg>
  )
}

const UptimeSVG = () => {
  return (
    <svg viewBox="0 0 64 64" style={{width: "64", height: "64", color:"#FF5F00"}}>
      <path fillRule="evenodd" clipRule="evenodd" d="M32 11C20.402 11 11 20.402 11 32C11 43.598 20.402 53 32 53V63C14.8792 63 1 49.1208 1 32C1 14.8792 14.8792 1 32 1C49.1208 1 63 14.8792 63 32H53C53 20.402 43.598 11 32 11Z" fill="#EDEAE5"></path>
      <path fillRule="evenodd" clipRule="evenodd" d="M50.8974 33.9866L48.9081 33.7799C48.9688 33.1955 49 32.6017 49 32C49 31.3983 48.9688 30.8045 48.9081 30.2201L50.8974 30.0134C50.9652 30.6663 51 31.3291 51 32C51 32.6709 50.9652 33.3337 50.8974 33.9866ZM50.7687 29.0268L48.793 29.3373C48.606 28.1477 48.2957 26.9995 47.8757 25.906L49.7427 25.1888C50.2126 26.4123 50.5597 27.6966 50.7687 29.0268ZM49.3616 24.2699L47.535 25.0844C47.0488 23.9941 46.4509 22.9639 45.7554 22.0083L47.3725 20.8314C48.1494 21.899 48.8179 23.0505 49.3616 24.2699ZM46.7664 20.0427L45.2128 21.3022C44.4643 20.379 43.621 19.5357 42.6978 18.7872L43.9573 17.2336C44.9885 18.0697 45.9303 19.0115 46.7664 20.0427ZM43.1686 16.6275L41.9917 18.2446C41.0361 17.5491 40.0059 16.9512 38.9156 16.465L39.7301 14.6384C40.9495 15.1821 42.101 15.8506 43.1686 16.6275ZM38.8112 14.2573L38.094 16.1243C37.0005 15.7043 35.8523 15.394 34.6627 15.207L34.9732 13.2313C36.3034 13.4403 37.5877 13.7874 38.8112 14.2573ZM33.9866 13.1026L33.7799 15.0919C33.1955 15.0312 32.6017 15 32 15C31.3983 15 30.8045 15.0312 30.2201 15.0919L30.0134 13.1026C30.6663 13.0348 31.3291 13 32 13C32.6709 13 33.3337 13.0348 33.9866 13.1026ZM29.0268 13.2313L29.3373 15.207C28.1477 15.394 26.9995 15.7043 25.906 16.1243L25.1888 14.2573C26.4123 13.7874 27.6966 13.4403 29.0268 13.2313ZM24.2699 14.6384L25.0844 16.465C23.9941 16.9512 22.9639 17.5491 22.0083 18.2446L20.8314 16.6275C21.899 15.8506 23.0505 15.1821 24.2699 14.6384ZM20.0427 17.2336L21.3022 18.7872C20.379 19.5357 19.5357 20.379 18.7872 21.3022L17.2336 20.0427C18.0697 19.0115 19.0115 18.0697 20.0427 17.2336ZM16.6275 20.8314L18.2446 22.0083C17.5491 22.9639 16.9512 23.9941 16.465 25.0844L14.6384 24.2699C15.1821 23.0505 15.8506 21.899 16.6275 20.8314ZM14.2573 25.1888L16.1243 25.906C15.7043 26.9995 15.394 28.1477 15.207 29.3373L13.2313 29.0268C13.4403 27.6966 13.7874 26.4123 14.2573 25.1888ZM13.1026 30.0134C13.0348 30.6663 13 31.3291 13 32C13 32.6709 13.0348 33.3337 13.1026 33.9866L15.0919 33.7799C15.0312 33.1955 15 32.6017 15 32C15 31.3983 15.0312 30.8045 15.0919 30.2201L13.1026 30.0134ZM13.2313 34.9732L15.207 34.6627C15.394 35.8523 15.7043 37.0005 16.1243 38.094L14.2573 38.8112C13.7874 37.5877 13.4403 36.3034 13.2313 34.9732ZM14.6384 39.7301L16.465 38.9156C16.9512 40.0059 17.5491 41.0361 18.2446 41.9917L16.6275 43.1686C15.8506 42.101 15.1821 40.9495 14.6384 39.7301ZM17.2336 43.9573L18.7872 42.6978C19.5357 43.621 20.379 44.4643 21.3022 45.2128L20.0427 46.7664C19.0115 45.9303 18.0697 44.9885 17.2336 43.9573ZM20.8314 47.3725L22.0083 45.7554C22.9639 46.4509 23.9941 47.0488 25.0844 47.535L24.2699 49.3616C23.0505 48.8179 21.899 48.1494 20.8314 47.3725ZM25.1888 49.7427C26.4123 50.2126 27.6966 50.5597 29.0268 50.7687L29.3373 48.793C28.1477 48.606 26.9995 48.2957 25.906 47.8757L25.1888 49.7427ZM30.0134 50.8974L30.2201 48.9081C30.8045 48.9688 31.3983 49 32 49C32.6017 49 33.1955 48.9688 33.7799 48.9081L33.9866 50.8974C33.3337 50.9652 32.6709 51 32 51C31.3291 51 30.6663 50.9652 30.0134 50.8974ZM34.9732 50.7687L34.6627 48.793C35.8523 48.606 37.0005 48.2957 38.094 47.8757L38.8112 49.7427C37.5877 50.2126 36.3034 50.5597 34.9732 50.7687ZM39.7301 49.3616L38.9156 47.535C40.0059 47.0488 41.0361 46.4509 41.9917 45.7554L43.1686 47.3725C42.101 48.1494 40.9495 48.8179 39.7301 49.3616ZM43.9573 46.7664L42.6978 45.2128C43.621 44.4643 44.4643 43.621 45.2128 42.6978L46.7664 43.9573C45.9303 44.9885 44.9885 45.9303 43.9573 46.7664ZM47.3725 43.1686L45.7554 41.9917C46.4509 41.0361 47.0488 40.0059 47.535 38.9156L49.3616 39.7301C48.8179 40.9495 48.1494 42.101 47.3725 43.1686ZM49.7427 38.8112L47.8757 38.094C48.2957 37.0005 48.606 35.8523 48.793 34.6627L50.7687 34.9732C50.5597 36.3034 50.2126 37.5877 49.7427 38.8112Z" fill="#EDEAE5"></path>
      <path fillRule="evenodd" clipRule="evenodd" d="M53.9833 50.9576L53.9833 64L45.9833 64L45.9833 50.9798L41.8929 55.2627L36.1075 49.7373L49.9789 35.2132L63.8887 49.7329L58.1118 55.2671L53.9833 50.9576Z" fill="#FF5F00"></path>
      <path fillRule="evenodd" clipRule="evenodd" d="M32.0002 22.5C32.8286 22.5 33.5002 23.1716 33.5002 24V34C33.5002 34.5497 33.1995 35.0554 32.7165 35.3179C32.2335 35.5804 31.6456 35.5577 31.1843 35.2587L25.1843 31.3698C24.4892 30.9193 24.2909 29.9904 24.7414 29.2953C25.192 28.6001 26.1208 28.4018 26.816 28.8524L30.5002 31.2403V24C30.5002 23.1716 31.1718 22.5 32.0002 22.5Z" fill="#FF5F00"></path>
    </svg>
  )
}

function HomeStatus() {
  const { serialNumber } = useContext(ControllerContext);
  return(
    <>
      <SectionOneContent>
        <SectionOneHeader>
          <SectionOneHeaderTitle>
            <SectionOneHeaderTitleImgDiv>
              <SectionOneHeaderTitleImg src={M16Icon} alt="mini-process" />
            </SectionOneHeaderTitleImgDiv>
            <SectionOneHeaderTitleName> Roberto System </SectionOneHeaderTitleName>
          </SectionOneHeaderTitle>
          <SectionOneHeaderDescription>
            <SectionOneHeaderDescriptionDiv>
              <div style={{ boxSizing: "inherit" }}>
                <HomeOnlineSVG />
              </div>
              <SectionOneHeaderDescriptionP> Home Online </SectionOneHeaderDescriptionP>
            </SectionOneHeaderDescriptionDiv>
            <SectionOneHeaderDescriptionButton>
              <ThreeDotsSVG />
            </SectionOneHeaderDescriptionButton>
          </SectionOneHeaderDescription>
        </SectionOneHeader>
        <SectionOneContentContent>
          <HomeUIDDiv>
            <HomeUIDTitle>
              Serial
            </HomeUIDTitle>
            <HomeUIDContent>
              <HomeUIDContentDescription>
                {serialNumber ? serialNumber :  '8A2D081726063952'}
              </HomeUIDContentDescription>
              <HomeUIDContentButton>
                <UDIButtonSVG />
              </HomeUIDContentButton>
            </HomeUIDContent>
          </HomeUIDDiv>
          <SystemAcessDiv>
            <SystemAcessTitle> System Acess </SystemAcessTitle>
            <SystemAcessContent>
              <SystemAcessContentDescription>
                <SystemAcessCheckSVG />
                Expires 04/12/2023, 10:06 PM
              </SystemAcessContentDescription>
            </SystemAcessContent>
          </SystemAcessDiv>
          <MonitoringAcessDiv>
            <MonitoringAcessTitle> Monitoring Acess </MonitoringAcessTitle>
            <MonitoringAcessContent>
              <MonitoringAcessDescription>
                <MonitoringAcessSVG />
                Monitoring Acess
              </MonitoringAcessDescription>
            </MonitoringAcessContent>
          </MonitoringAcessDiv>
          <OverallSystemStatusDiv>
            <OverallSystemStatusContent>
              <OverallSystemStatusTitle> Overall System Status </OverallSystemStatusTitle>
              <OverallSystemStatusDescription>
                Good
              </OverallSystemStatusDescription>
            </OverallSystemStatusContent>
          </OverallSystemStatusDiv>
          <ChecksDiv>
            <ChecksContent>
              <ChecksIconDiv>
                <div style={{ boxSizing: "inherit" }}>
                  <ChecksOKSVG />
                </div>
              </ChecksIconDiv>
              <ChecksDescription>
                Control Connection
              </ChecksDescription>
            </ChecksContent>
            <ChecksContent>
              <ChecksIconDiv>
                <div style={{ boxSizing: "inherit" }}>
                  <ChecksOKSVG />
                </div>
              </ChecksIconDiv>
              <ChecksDescription>
                Diagnosctic Reports
              </ChecksDescription>
            </ChecksContent>
            <ChecksContent>
              <ChecksIconDiv>
                <div style={{ boxSizing: "inherit" }}>
                  <ChecksOKSVG />
                </div>
              </ChecksIconDiv>
              <ChecksDescription>
                Controller
              </ChecksDescription>
            </ChecksContent>

          </ChecksDiv>
          <DashboardDiv>
            <DashboardContent>
              <DashboardTitle>System Load</DashboardTitle>
              <DashboardValue>
                7
                <DashboardValueSpan> %</DashboardValueSpan>
              </DashboardValue>
            </DashboardContent>
            <DashboardIconDiv>
              <DashboardIconDivContent>
                <DashboardIcon>
                  <CircularProgressBarSVG />
                </DashboardIcon>
              </DashboardIconDivContent>
            </DashboardIconDiv>
          </DashboardDiv>
          <DashboardDiv>
            <DashboardContent>
              <DashboardTitle>Free Space</DashboardTitle>
              <DashboardValue>
                12
                <DashboardValueSpan> %</DashboardValueSpan>
              </DashboardValue>
            </DashboardContent>
            <DashboardIconDiv>
              <DashboardIconDivContent>
                <DashboardIcon>
                  <CircularProgressBarSVG />
                </DashboardIcon>
              </DashboardIconDivContent>
            </DashboardIconDiv>
          </DashboardDiv>
          <DashboardDiv>
            <DashboardContent>
              <DashboardTitle>Uptime</DashboardTitle>
              <DashboardValue>
                0
                <DashboardValueSpan> d</DashboardValueSpan>
              </DashboardValue>
            </DashboardContent>
            <DashboardIconDiv>
              <DashboardIconDivContent>
                <DashboardIcon>
                  <UptimeSVG />
                </DashboardIcon>
              </DashboardIconDivContent>
            </DashboardIconDiv>
          </DashboardDiv>
        </SectionOneContentContent>
      </SectionOneContent>
      <SectionOneSection>
        <MultipleUpload />
      </SectionOneSection>
    </>
  )
}

export default HomeStatus;